import { apiRequest } from '@/lib/api-client';

export interface Notification {
  id: string;
  type: string;
  title: string;
  body: string;
  data: Record<string, unknown>;
  read: boolean;
  createdAt: string;
}

export const notificationsApi = {
  list: () => apiRequest<{ items: Notification[]; unread: number }>('/api/v1/notifications'),
  markRead: (id: string) =>
    apiRequest<{ read: boolean }>(`/api/v1/notifications/${id}/read`, { method: 'POST' }),
  markAllRead: () =>
    apiRequest<{ read: boolean }>('/api/v1/notifications/read-all', { method: 'POST' }),
  vapidKey: () => apiRequest<{ publicKey: string | null }>('/api/v1/push/public-key'),
  subscribe: (sub: { endpoint: string; keys: { p256dh: string; auth: string } }) =>
    apiRequest<{ subscribed: boolean }>('/api/v1/push/subscribe', { method: 'POST', body: sub }),
};
